module.exports = {
	"AF": "Afghánistán",
	"AX": "Ålandy",
	"AL": "Albánie",
	"DZ": "Alžírsko",
	"AS": "Americká Samoa",
	"VI": "Americké Panenské ostrovy",
	"AD": "Andorra",
	"AO": "Angola",
	"AI": "Anguilla",
	"AQ": "Antarktida",
	"AG": "Antigua a Barbuda",
	"AR": "Argentina",
	"AM": "Arménie",
	"AW": "Aruba",
	"AU": "Austrálie",
	"AZ": "Ázerbájdžán",
	"BS": "Bahamy",
	"BH": "Bahrajn",
	"BD": "Bangladéš",
	"BB": "Barbados",
	"BE": "Belgie",
	"BZ": "Belize",
	"BY": "Bělorusko",
	"BJ": "Benin",
	"BM": "Bermudy",
	"BT": "Bhútán",
	"BO": "Bolívie",
	"BQ": "Bonaire, Svatý Eustach a Saba",
	"BA": "Bosna a Hercegovina",
	"BW": "Botswana",
	"BV": "Bouvetův ostrov",
	"BR": "Brazílie",
	"IO": "Britské indickooceánské území",
	"VG": "Britské Panenské ostrovy",
	"BN": "Brunej",
	"BG": "Bulharsko",
	"BF": "Burkina Faso",
	"BI": "Burundi",
	"CK": "Cookovy ostrovy",
	"CW": "Curaçao",
	"TD": "Čad",
	"ME": "Černá Hora",
	"CZ": "Česko",
	"CN": "Čína",
	"DK": "Dánsko",
	"CD": "Demokratická republika Kongo",
	"DM": "Dominika",
	"DO": "Dominikánská republika",
	"DJ": "Džibutsko",
	"EG": "Egypt",
	"EC": "Ekvádor",
	"ER": "Eritrea",
	"EE": "Estonsko",
	"ET": "Etiopie",
	"FO": "Faerské ostrovy",
	"FK": "Falklandy (Malvíny)",
	"FJ": "Fidži",
	"PH": "Filipíny",
	"FI": "Finsko",
	"FR": "Francie",
	"GF": "Francouzská Guyana",
	"TF": "Francouzská jižní a antarktická území",
	"PF": "Francouzská Polynésie",
	"GA": "Gabon",
	"GM": "Gambie",
	"GH": "Ghana",
	"GI": "Gibraltar",
	"GD": "Grenada",
	"GL": "Grónsko",
	"GE": "Gruzie",
	"GP": "Guadeloupe",
	"GU": "Guam",
	"GT": "Guatemala",
	"GN": "Guinea",
	"GW": "Guinea-Bissau",
	"GG": "Guernsey",
	"GY": "Guyana",
	"HT": "Haiti",
	"HM": "Heardův ostrov a McDonaldovy ostrovy",
	"HN": "Honduras",
	"HK": "Hongkong",
	"CL": "Chile",
	"HR": "Chorvatsko",
	"IN": "Indie",
	"ID": "Indonésie",
	"IQ": "Irák",
	"IR": "Írán",
	"IE": "Irsko",
	"IS": "Island",
	"IT": "Itálie",
	"IL": "Izrael",
	"JM": "Jamajka",
	"JP": "Japonsko",
	"YE": "Jemen",
	"JE": "Jersey",
	"ZA": "Jihoafrická republika",
	"GS": "Jižní Georgie a Jižní Sandwichovy ostrovy",
	"KR": "Jižní Korea",
	"SS": "Jižní Súdán",
	"JO": "Jordánsko",
	"KY": "Kajmanské ostrovy",
	"KH": "Kambodža",
	"CM": "Kamerun",
	"CA": "Kanada",
	"CV": "Kapverdy",
	"QA": "Katar",
	"KZ": "Kazachstán",
	"KE": "Keňa",
	"KI": "Kiribati",
	"CC": "Kokosové ostrovy",
	"CO": "Kolumbie",
	"KM": "Komory",
	"CG": "Kongo",
	"CR": "Kostarika",
	"CU": "Kuba",
	"KW": "Kuvajt",
	"CY": "Kypr",
	"KG": "Kyrgyzstán",
	"LA": "Laos",
	"LS": "Lesotho",
	"LB": "Libanon",
	"LR": "Libérie",
	"LY": "Libye",
	"LI": "Lichtenštejnsko",
	"LT": "Litva",
	"LV": "Lotyšsko",
	"LU": "Lucembursko",
	"MO": "Macao",
	"MG": "Madagaskar",
	"HU": "Maďarsko",
	"MK": "Makedonie",
	"MY": "Malajsie",
	"MW": "Malawi",
	"MV": "Maledivy",
	"ML": "Mali",
	"MT": "Malta",
	"IM": "Ostrov Man",
	"MA": "Maroko",
	"MH": "Marshallovy ostrovy",
	"MQ": "Martinik",
	"MU": "Mauricius",
	"MR": "Mauritánie",
	"YT": "Mayotte",
	"UM": "Menší odlehlé ostrovy USA",
	"MX": "Mexiko",
	"FM": "Mikronésie",
	"MD": "Moldavsko",
	"MC": "Monako",
	"MN": "Mongolsko",
	"MS": "Montserrat",
	"MZ": "Mosambik",
	"MM": "Myanmar",
	"NA": "Namibie",
	"NR": "Nauru",
	"DE": "Německo",
	"NP": "Nepál",
	"NE": "Niger",
	"NG": "Nigérie",
	"NI": "Nikaragua",
	"NU": "Niue",
	"NL": "Nizozemsko",
	"NF": "Norfolk",
	"NO": "Norsko",
	"NC": "Nová Kaledonie",
	"NZ": "Nový Zéland",
	"OM": "Omán",
	"PK": "Pákistán",
	"PW": "Palau",
	"PS": "Palestinská autonomie",
	"PA": "Panama",
	"PG": "Papua-Nová Guinea",
	"PY": "Paraguay",
	"PE": "Peru",
	"PN": "Pitcairnovy ostrovy",
	"CI": "Pobřeží slonoviny",
	"PL": "Polsko",
	"PR": "Portoriko",
	"PT": "Portugalsko",
	"AT": "Rakousko",
	"RE": "Réunion",
	"GQ": "Rovníková Guinea",
	"RO": "Rumunsko",
	"RU": "Rusko",
	"RW": "Rwanda",
	"GR": "Řecko",
	"PM": "Saint-Pierre a Miquelon",
	"SV": "Salvador",
	"WS": "Samoa",
	"SM": "San Marino",
	"SA": "Saúdská Arábie",
	"SN": "Senegal",
	"KP": "Severní Korea",
	"MP": "Severní Mariany",
	"SC": "Seychely",
	"SL": "Sierra Leone",
	"SG": "Singapur",
	"SK": "Slovensko",
	"SI": "Slovinsko",
	"SO": "Somálsko",
	"AE": "Spojené arabské emiráty",
	"GB": "Spojené království",
	"US": "Spojené státy americké",
	"RS": "Srbsko",
	"CF": "Středoafrická republika",
	"SD": "Súdán",
	"SR": "Surinam",
	"SH": "Svatá Helena, Ascension a Tristan da Cunha",
	"LC": "Svatá Lucie",
	"BL": "Svatý Bartoloměj",
	"KN": "Svatý Kryštof a Nevis",
	"MF": "Svatý Martin (francouzská část)",
	"SX": "Svatý Martin (nizozemská část)",
	"ST": "Svatý Tomáš a Princův ostrov",
	"VC": "Svatý Vincenc a Grenadiny",
	"SZ": "Svazijsko",
	"SY": "Sýrie",
	"SB": "Šalamounovy ostrovy",
	"ES": "Španělsko",
	"SJ": "Špicberky a Jan Mayen",
	"LK": "Šrí Lanka",
	"SE": "Švédsko",
	"CH": "Švýcarsko",
	"TJ": "Tádžikistán",
	"TZ": "Tanzanie",
	"TH": "Thajsko",
	"TW": "Tchaj-wan",
	"TG": "Togo",
	"TK": "Tokelau",
	"TO": "Tonga",
	"TT": "Trinidad a Tobago",
	"TN": "Tunisko",
	"TR": "Turecko",
	"TM": "Turkmenistán",
	"TC": "Turks a Caicos",
	"TV": "Tuvalu",
	"UG": "Uganda",
	"UA": "Ukrajina",
	"UY": "Uruguay",
	"UZ": "Uzbekistán",
	"CX": "Vánoční ostrov",
	"VU": "Vanuatu",
	"VA": "Vatikán",
	"VE": "Venezuela",
	"VN": "Vietnam",
	"TL": "Východní Timor",
	"WF": "Wallis a Futuna",
	"ZM": "Zambie",
	"EH": "Západní Sahara",
	"ZW": "Zimbabwe",
	"XK": "Kosovo"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/i18n-iso-countries/langs/cs.json
 ** module id = 434
 ** module chunks = 0 1
 **/